<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="modelValue">
        <Dialog
            as="div"
            class="inset-0 fixed z-10 overflow-y-auto"
            @close="closeModal"
        >
            <div
                class="px-4 pb-20 pt-4 sm:block sm:p-0 flex min-h-screen items-end justify-center text-center"
            >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay
                        class="inset-0 bg-iron-500 bg-opacity-75 fixed transition-opacity"
                    />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="sm:inline-block sm:h-screen sm:align-middle hidden"
                    aria-hidden="true"
                    >&#8203;</span
                >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="rounded-lg bg-white px-4 pb-4 pt-5 shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle inline-block transform overflow-hidden text-left align-bottom transition-all"
                    >
                        <div
                            class="right-0 top-0 pr-4 pt-4 sm:block absolute hidden"
                        >
                            <button
                                type="button"
                                class="rounded-md bg-white text-iron-400 hover:text-iron-500 focus:ring-indigo-500 focus:ring-2 focus:ring-offset-2 focus:outline-none"
                                @click="closeModal"
                            >
                                <span class="sr-only">Close</span>
                                <XCircleIcon
                                    class="h-6 w-6"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                        <div class="sm:flex sm:items-start">
                            <div
                                class="h-12 w-12 bg-error-100 sm:mx-0 sm:h-10 sm:w-10 mx-auto flex flex-shrink-0 items-center justify-center rounded-full"
                            >
                                <ExclamationTriangleIcon
                                    class="h-6 w-6 text-error-600"
                                    aria-hidden="true"
                                />
                            </div>

                            <div
                                class="mt-3 sm:ml-4 sm:mt-0 sm:text-left text-center"
                            >
                                <DialogTitle
                                    as="h3"
                                    class="text-lg font-medium leading-6 text-iron-900"
                                >
                                    {{
                                        $t(
                                            "event_types.event_detail.remove_time_slot.title",
                                        )
                                    }}
                                </DialogTitle>
                                <div class="mt-2">
                                    <p class="text-sm text-iron-500">
                                        {{
                                            $t(
                                                "event_types.event_detail.remove_time_slot.description",
                                                {
                                                    from: formatTime(
                                                        event.start,
                                                    ),

                                                    to: formatTime(event.end),
                                                },
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button
                                type="button"
                                class="rounded-md bg-error-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-error-700 focus:ring-error-500 sm:ml-3 sm:w-auto sm:text-sm inline-flex w-full justify-center border border-transparent focus:ring-2 focus:ring-offset-2 focus:outline-none"
                                @click="excludeDate"
                            >
                                {{ $t("remove") }}
                            </button>

                            <button
                                type="button"
                                class="mt-3 rounded-md border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:text-iron-500 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm inline-flex w-full justify-center border focus:ring-2 focus:ring-offset-2 focus:outline-none"
                                @click="closeModal"
                            >
                                {{ $t("cancel") }}
                            </button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts" setup>
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import {
    XCircleIcon,
    ExclamationTriangleIcon,
} from "@heroicons/vue/24/outline";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";
import { format } from "date-fns";
const props = defineProps({
    modelValue: Boolean,
    event: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits([
    "update:modelValue",
    "delete-event",
    "excluded-date",
]);

const excludeDate = () => {
    router.post(
        route("app.event-types.excluded-dates.store", {
            eventType: props.event.event_type_id,
        }),
        {
            start: props.event.start,
            end: props.event.end,
        },
        {
            onFinish: () => {
                emit("excluded-date");
                closeModal();
            },
        },
    );
    closeModal();
};

function formatTime(date: string) {
    return format(new Date(date), "HH:mm");
}

const closeModal = () => {
    emit("update:modelValue", false);
};
</script>
